"use client";
import { createContext, type ReactNode, useContext, useState } from "react";

export type Property = {
	id: string;
	name: string;
	address: string;
};

interface PropertyContextType {
	selectedProperty?: Property;
	properties: Property[];
	setSelectedProperty: (property: Property) => void;
	setProperties: (properties: Property[]) => void;
}

const PropertyContext = createContext<PropertyContextType | undefined>(
	undefined,
);

export function PropertyProvider({ children }: { children: ReactNode }) {
	const [selectedProperty, setSelectedProperty] = useState<Property>();
	const [properties, setProperties] = useState<Property[]>([]);

	return (
		<PropertyContext.Provider
			value={{
				selectedProperty,
				properties,
				setSelectedProperty,
				setProperties,
			}}
		>
			{children}
		</PropertyContext.Provider>
	);
}

export function useProperty() {
	const context = useContext(PropertyContext);
	if (context === undefined) {
		throw new Error("useProperty must be used within a PropertyProvider");
	}
	return context;
}
